import React from "react";
import useChooseUser from "./hooks";
import { MultiPickerListProps } from "../props";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import UserWithAvatar from "components/Atoms/UserWithAvatar";

interface Props extends MultiPickerListProps<server.dto.UserSmall> {
  canChooseDeactivated?: boolean
  canChooseExternal?: boolean
}

const MultiUserList = (props: Props) => {
  const chooseUser = useChooseUser();

  const displayLifecycles = props.canChooseDeactivated;
  const displayEnvironment = props.canChooseExternal;

  const isActiveSelected = chooseUser.instruction.lifeCycles.includes("active");
  const isDeactivatedSelected = chooseUser.instruction.lifeCycles.includes("archived");

  const isInternalSelected = chooseUser.instruction.environment === "internal";
  const isExternalSelected = chooseUser.instruction.environment === "external";

  return <MultiPickerListWithSelectedItems
    instruction={chooseUser.instruction}
    onInstructionChange={i => chooseUser.setInstruction(i)}
    queryKey="multiUsers"
    api={instruction => window.CoreApi.UserToClient.PaginatedSmall(instruction).then(resp => ({
      ...resp,
      data: {
        ...resp.data,
        data: resp.data?.data?.map(userToClient => userToClient.user)
      },
    }))}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}

    onChange={props.onChange}
    renderListItem={user => <UserWithAvatar user={user} avatarSize="avatar" />}
    getId={user => user.userId}
    getLabel={user => <div>{user.fullName}</div>}
    value={props.value}

    filter1={displayEnvironment
      ? {
        leftButton: {
          type: "tertiary",
          isActive: isInternalSelected,
          label: RESX.UserType.Internal,
          onClick: () => { chooseUser.setEnvironment("internal"); }
        },
        rightButton: {
          type: "tertiary",
          isActive: isExternalSelected,
          label: RESX.UserType.External,
          onClick: () => { chooseUser.setEnvironment("external"); }
        }
      }
      : undefined}

    filter2={displayLifecycles
      ? {
        leftButton: {
          type: "primary",
          isActive: isActiveSelected,
          label: RESX.SoUser.Active,
          onClick: () => { chooseUser.setLifecycles(["active"]); }
        },
        rightButton: {
          type: "warning",
          isActive: isDeactivatedSelected,
          label: RESX.SoUser.Deactivated,
          onClick: () => { chooseUser.setLifecycles(["archived"]); }
        }
      }
      : undefined}
  />
};

export default MultiUserList;